import { defineMessages } from '@transcend-io/internationalization';

export const selectPartitionMessages = defineMessages(
  'privacy-center.components.SelectPartition.selectPartition',
  {
    selectPartition: {
      defaultMessage: 'What category would you like to change preferences for?',
      description: 'The label text displayed for partition selection dropdown.',
    },
    selectedPartition: {
      defaultMessage: 'Currently selected category:',
      description:
        'The label text displayed for partition selection dropdown when "Allow Partition Selection" is disabled.',
    },
  },
);
